import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { HttpClientProvider } from '@services/http/client/http-client-provider';
import { articleType } from '@services/http/remote-calls/snf-api/articles/article.type';
import { GetArticlesRemoteCall } from '@services/http/remote-calls/snf-api/articles/get-articles.http-remote-call';
import StorieSuccessoCarousel from '@components/storie-successo/carousel/carousel';
import classNames from 'classnames';
import styles from './storie-successo.module.css';
import { PageHead } from '../../components/common/head/page-head';
import { Navbar } from '../../components/common/navbar/navbar';
import { useSiteData } from '../../context/site-data-context';

const mapperStoriesServices = (successStories = []) => {
  const services = [];
  successStories.forEach((successStory) => {
    const idServiceStory = successStory?.service?._id;
    const filteredStories = successStories.filter(
      (story) => story?.service?._id === idServiceStory
    );
    if (!filteredStories?.length > 0) {
      return;
    }
    const foundMappedStory = services.find((story) => story?._id === idServiceStory);
    if (!foundMappedStory) {
      services.push({
        ...successStory?.service,
        stories: filteredStories
      });
    }
  });
  return services;
};

export default function StorieSuccessoPage() {
  const intl = useIntl();
  const { serviceCategories, technologyCategories } = useSiteData();
  const [services, setServices] = useState([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const httpClient = HttpClientProvider.getInstance();
      const successStoriesRemoteCall = new GetArticlesRemoteCall(intl.locale, [articleType.STORY]);
      const successStories = await httpClient.execute(successStoriesRemoteCall);
      if (!cancelled) setServices(mapperStoriesServices(successStories));
    })();
    return () => {
      cancelled = true;
    };
  }, [intl.locale]);

  return (
    <>
      <PageHead
        title={intl.formatMessage({
          defaultMessage: 'Sistemi Informativi S.r.l. - An IBM company - News ed eventi',
          description: 'News ed eventi - Page title'
        })}
        description={intl.formatMessage({
          defaultMessage: 'Sistemi Informativi S.r.l. - News ed eventi',
          description: 'News ed eventi - Page description'
        })}
      />
      <Navbar
        navCssClasses={classNames(styles.navbarBackground, 'position-fixed')}
        navLinkCssClasses={styles.navItem}
        serviceCategories={serviceCategories}
        technologyCategories={technologyCategories}
      />

      <main role="main" className="mt-5">
        <div className={`snf-font-32 snf-font-w6 ${styles.pageHeader}`}>
          {intl.formatMessage({ defaultMessage: 'Storie di successo' })}
        </div>
        <div>
          {services?.map((service) => (
            <div key={service?._id}>
              <div
                className={`snf-color-black snf-font-20 text-uppercase font-weight-bold ${
                  styles.subHeader
                }`}
              >
                {service?.title[intl.locale]}
              </div>
              <div className="mb-5">
                <StorieSuccessoCarousel id={service?._id} stories={service?.stories} />
              </div>
            </div>
          ))}
        </div>
      </main>
    </>
  );
}
